import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {   
    // eslint-disable-next-line no-unused-vars
    async getProductParams({ commit }) {
      // eslint-disable-next-line no-useless-catch
      try {
        const response = await api.get(`/site/products/params`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
    // eslint-disable-next-line no-unused-vars
    async getProductDetails({ commit }, id) {
      // eslint-disable-next-line no-useless-catch
      try {
        const response = await api.get(`/site/products/details/${id}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
    // eslint-disable-next-line no-unused-vars
    async searchProducts({ commit }, data) {
      // eslint-disable-next-line no-useless-catch
      try {
        // Transforma data em uma query string, convertendo objetos em JSON strings
        const queryString = Object.keys(data)
          .map((key) => {
            const value = data[key];
            // Verifica se o valor é um objeto e faz JSON.stringify
            return `${encodeURIComponent(key)}=${encodeURIComponent(
              typeof value === 'object' ? JSON.stringify(value) : value
            )}`;
          })
          .join('&');
          
        const response = await api.get(`/site/products/search?${queryString}`);
        return response && response.data ? response.data : null;
      } catch (error) {
        throw error;
      }
    },
  },
  getters: {},
}
